import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Severity } from '../../model/ISystemStatusMessage'
import { severityIcon, severityToken } from '../../utils/severityTokens'
import { sanitizeBody } from '../../utils/sanitizeHtml'

interface IProps {
  severity: Severity
  title: string
  body?: string
}

// Condensed preview of the banner row, matching SystemStatusRow's look
// (background + left accent border + icon + title, with the body underneath).
const BannerPreview = ({ severity, title, body }: IProps) => {
  const token = severityToken(severity)
  const Icon = severityIcon(severity)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1rem',
        minHeight: 44,
        py: '10px',
        pr: 1,
        backgroundColor: token.bg,
        borderLeft: `5px solid ${token.rail}`
      }}
    >
      <Icon sx={{ fontSize: 19, color: token.icon, ml: '8px', mt: '1px' }} />
      <Box sx={{ minWidth: 0, flex: '1 1 auto' }}>
        <Typography
          component="div"
          sx={{
            fontWeight: 500,
            fontSize: '1rem',
            color: token.title,
            overflowWrap: 'anywhere'
          }}
        >
          {title || 'Message title'}
        </Typography>
        {body && (
          <Box
            sx={{
              mt: '4px',
              fontSize: 14,
              lineHeight: 1.6,
              color: token.body,
              overflowWrap: 'anywhere',
              whiteSpace: 'pre-wrap',
              '& a': { color: '#0288D1', textDecoration: 'underline' },
              '& p': { margin: '0 0 8px' },
              '& ul, & ol': {
                margin: '4px 0',
                paddingLeft: '20px',
                whiteSpace: 'normal'
              },
              '& li': { margin: 0 }
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeBody(body) }}
          />
        )}
      </Box>
    </Box>
  )
}

export default BannerPreview
